import {Component, OnInit} from '@angular/core';
import {ActivatedRoute, Params, Router} from '@angular/router';
import {DatePipe, Location} from '@angular/common';
import {
  formatPhoneNumeric,
  phoneToCountry,
  toCardExpireDateString,
  toDateString,
  toDateTimeString
} from '../../../providers/app-date-adapter';
import {Order, Referral} from '../../../dto/order';
import {OrdersService} from '../../services/orders.service';
import {MatDialog} from '@angular/material/dialog';
import {MatSnackBar} from '@angular/material/snack-bar';
import {OrderStatus} from '../../../dto/order-status';
import {OrderCancellationModel} from '../../../models/order-cancellation-model';
import {OrderCancelDialogComponent} from '../../../shared/order-cancel-dialog/order-cancel-dialog.component';
import {RoleService} from '../../../services/role.service';
import {WebIdTransactionProvider, IdentStatus} from '../../../dto/ident-status';
import {WebIdTransaction} from '../../../dto/web-id-transaction';
import {CardsService} from '../../services/cards.service';
import {Card, CustomerOverviewCardContainer} from '../../../dto/card';
import {PrevNextModel} from '../../../models/prev-next-model';
import {getTableFilters} from '../../../helpers/storage-helper';
import {ResendWebidDialogComponent} from '../../../shared/resend-webid/resend-webid-dialog.component';
import {ResendWebidModel} from '../../../models/resend-webid-model';
import {EventLog} from '../../../dto/event-log';
import {EventLogService} from '../../../services/crud/event-log.service';
import {ContentRowField} from '../../../shared/content-row/content-row.component';
import {Customer} from '../../../dto/customer';
import {PepStatus} from '../../../dto/pep-status';
import {CardReorderReason} from '../../../dto/card-reorder-reason';
import {ToastService} from 'angular-toastify';
import {CityInfo} from '../../../dto/GeoIp/city-info';
import {GeoIpService} from '../../../services/geo-ip.service';
import {PrevNextIdModel} from '../../../models/prev-next-id-model';
import {getPepStatusColor, getPepStatusText} from "../../../helpers/pep-status-helper";

@Component({
  selector: 'app-order-view',
  templateUrl: './order-view.component.html',
  styleUrls: ['./order-view.component.css']
})
export class OrderViewComponent implements OnInit {

  order: Order;
  card: Card | null;
  referral: Referral|null;
  prevNext: PrevNextModel;
  loadingOrder: boolean;
  loadCardData: boolean;
  loadReferralData: boolean;
  orderId: number;
  orderStatus = OrderStatus;

  identStatus = IdentStatus;
  pepStatus = PepStatus;

  logs: EventLog[];

  fieldsSource = [
    { header: 'Source', cell: (row: Order) => `${row.source}` } as ContentRowField<Order>,
    { header: 'Platform', icon: (row: Order) => {
        if ( row.appDevice != null) {
          if ( row.appDevice.os == 1 ) { // ios
            return 'apple';
          } else if ( row.appDevice.os == 2 ) { // android
            return 'android';
          }
        }
        return null;
      }, cell: (row: Order) => {
        if ( row.appDevice != null) {
          if ( row.appDevice.os == 1 ) { // ios
            return 'iOS';
          } else if ( row.appDevice.os == 2 ) { // android
            return 'Android';
          }
        }
      } } as ContentRowField<Order>,
    { header: 'Brand', cell: (row: Order) => `${row.appDevice.brandName}` } as ContentRowField<Order>,
    { header: 'Last sign-in', cell: (row: Order) => `${row.appDevice.firebaseTokenDate ? this.datePipe.transform(row.appDevice.firebaseTokenDate) : '-'}` } as ContentRowField<Order>,
    { header: 'Device', cellColor: (row: Order) => `${row.appDevice.isBlacklisted ? 'red' : 'forestgreen'}`, cell: (row: Order) => `${row.appDevice.isBlacklisted ? 'BLACKLISTED' : 'OK'}` } as ContentRowField<Order>,
  ];

  fieldsReferral = [
    { header: 'Referrer', link: (row: Referral) => '../../customers-overview/' + row.customerId, cell: (row: Referral) => `${row.customer.firstName} ${row.customer.lastName}` } as ContentRowField<Referral>,
    { header: 'Status', cell: (row: Referral) => {

      if ( row.status == 1 ) {
return 'Referral accepted by referee';
}
        if ( row.status == 2 ) {
return 'Ordered';
}
        if ( row.status == 3 ) {
return 'Pending bonus';
}
        if ( row.status == 4 ) {
return 'Completed';
}

        if ( row.status == 9 ) {
return 'Expired';
}

      } } as ContentRowField<Referral>,
    { header: 'Transactions', cell: (row: Referral) => `${row.numberOfTransactions}/${row.targetNumberOfTransactions}` } as ContentRowField<Referral>,
    { header: 'Loads', cell: (row: Referral) => `${row.numberOfLoads}/${row.targetNumberOfLoads}` } as ContentRowField<Referral>,
    { header: 'Identified', cell: (row: Referral) => `${row.identified}` } as ContentRowField<Referral>,
    { header: 'Ordered', cell: (row: Referral) => `${row.ordered}` } as ContentRowField<Referral>,
    { header: 'Phone', cell: (row: Referral) => `+${row.phoneNumber}` } as ContentRowField<Referral>,

  ];


  fields = [
    { header: 'Customer', icon: (row: Order) => 'visibility', link: (row: Order) => '../../customers-overview/' + (row.customerId || ''), cell: (row: Order) => `Customer` } as ContentRowField<Order>,
    { header: 'ExternalRef', cell: (row: Order) => `${row.externalRef}` } as ContentRowField<Order>,
    { header: 'Card name', cell: (row: Order) => `${row.cardName}` } as ContentRowField<Order>,
    { header: 'Invoice number', link: (row: Order) => (row?.invoiceId ? `/invoices/${row.invoiceId}` : null), cell: (row: Order) => `${row.invoiceNumber || '(none)'}` } as ContentRowField<Order>,
    { header: 'Partner Customer ID', cell: (row: Order) => `${row.partnerCustomerId || ''}` } as ContentRowField<Order>,
    { header: 'Sex', cell: (row: Order) => `${row.sex}` } as ContentRowField<Order>,
    { header: 'Title', cell: (row: Order) => `${row.title}` } as ContentRowField<Order>,
    { header: 'First Name', cell: (row: Order) => `${row.firstName}` } as ContentRowField<Order>,
    { header: 'Last Name', cell: (row: Order) => `${row.lastName}` } as ContentRowField<Order>,
    { header: 'Date of birth', cell: (row: Order) => `${toDateString(row.dob) || ''}` } as ContentRowField<Order>,
    { header: 'Email', cell: (row: Order) => `${row.email}`, copyCellActive: (row: Order) => true } as ContentRowField<Order>,
    { header: 'Mobile', cellFlag: (row: Order) => phoneToCountry(''+row.phone), cell: (row: Order) => `${formatPhoneNumeric(row.phone)}`, copyCellActive: (row: Order) => true, } as ContentRowField<Order>,
    { header: 'Product', cell: (row: Order) => `${row.productInternalName || row.productShortName || row.productName}` } as ContentRowField<Order>,
    { header: 'Company', cell: (row: Order) => `${row.companyName}` } as ContentRowField<Order>,
    { header: 'Address', cell: (row: Order) => `${row.address}` } as ContentRowField<Order>,
    { header: 'City', cell: (row: Order) => `${row.city}` } as ContentRowField<Order>,
    { header: 'Zip Code', cell: (row: Order) => `${row.zipCode}` } as ContentRowField<Order>,
    { header: 'Country', cell: (row: Order) => `${row.countryName}` } as ContentRowField<Order>,
    { header: 'Nationality', cell: (row: Order) => `${row.nationality}` } as ContentRowField<Order>,
    {header: 'IP Address', cellFlag: (row: Order) => this.ipCityInfo?.countryAlphaIsoCode || null
      , cell: (row: Order) => {
        const ret = row.ipAddress || '';
        if ( ret && this.ipCityInfo ) {
          //ret += " (" + this.ipCityInfo.postCode + " " + this.ipCityInfo.city + " " + this.ipCityInfo.countryName + ")"
        }
        return ret;

      }} as ContentRowField<Order>,
    { header: 'Order date', cell: (row: Order) => `${toDateString(row.orderDate) || ''}` } as ContentRowField<Order>,
    { header: 'Awaiting shipment date', cell: (row: Order) => `${toDateString(row.awaitingShipmentDate) || ''}` } as ContentRowField<Order>,
    { header: 'Shipping date', cell: (row: Order) => `${toDateString(row.shippedDate) || ''}` } as ContentRowField<Order>,
    { header: 'Status', cell: (row: Order) => `${row.statusName}` } as ContentRowField<Order>,

    { header: 'Load amount', icon: (row: Order) => {
      if ( row.loadAmount > 0 ) {
        return null;
      }
      return null;
      },
      iconColor: (row: Order) => {
          if ( row.loadAmount > 0 ) {
            return 'dodgerblue';
          }
        return null;
      }, cell: (row: Order) => `${row.loadAmount || ''}` } as ContentRowField<Order>,

    { header: 'Order language', cell: (row: Order) => {
      switch (row.orderLanguage) {
        case 0: return 'german';
        case 1: return 'english';
        case 2: return 'norwegian';
        case 3: return 'spanish';
        case 4: return 'italian';
        case 5: return 'french';
        default: return '(unknown)';
      }

      } } as ContentRowField<Order>,
    { header: 'Ident Txn ID', cell: (row: Order) => `${(row.webIdTransaction || ({} as WebIdTransaction)).id || 'No Ident'}` } as ContentRowField<Order>,

    {header: 'Ident Status',
      iconColor: (row: Order) => {
        if ( !row.webIdTransaction ) {
          return false;
        }
        if ( row.webIdTransaction.status == IdentStatus.fail ) {
          return '#ff0000';
        }
        if ( row.webIdTransaction.status == IdentStatus.pending ) {
          return '#547bde';
        }
        if ( row.webIdTransaction.status == IdentStatus.success ) {
          return '#8bc34a';
        }
      }, icon: (row: Order) => {
        if ( !row.webIdTransaction ) {
          return false;
        }
        if ( row.webIdTransaction.status == IdentStatus.fail ) {
          return 'beenhere';
        }
        if ( row.webIdTransaction.status == IdentStatus.pending ) {
          return 'access_time';
        }
        if ( row.webIdTransaction.status == IdentStatus.success ) {
          return 'beenhere';
        }
      },
      cell: (row: Order) => `${IdentStatus[(row.webIdTransaction || ({} as WebIdTransaction)).status] || 'No Ident'}` } as ContentRowField<Order>,

    {
      header: 'PEP Status',
      iconColor: row=> getPepStatusColor(row.webIdTransaction?.pepStatus), icon: (_) => 'perm_identity',
      cell: row => getPepStatusText(row.webIdTransaction?.pepStatus),
    } as ContentRowField<Order>,

    { header: 'Ident Url', isExternalLink: row => true, link: row => row.webIdTransaction ? row.webIdTransaction.url : null, cell: row => row.webIdTransaction ? row.webIdTransaction.id : '-' } as ContentRowField<Order>,

    { header: 'Ident Provider', cell: (row: Order) => `${WebIdTransactionProvider[(row.webIdTransaction || ({} as WebIdTransaction)).providerCode] || 'none' }` } as ContentRowField<Order>,

  ] as ContentRowField<Order>[];


  reorderFields = [
    { header: 'Reordered Card', icon: (row: Order) => 'visibility', link: (row: Order) => '../../cards/' + (row.reorderedCard?.id || ''), cell: (row: Order) => `${row.reorderedCard?.token}` } as ContentRowField<Order>,
    { header: 'Reorder Reason', cell: (row: Order) => {
      switch (row.reorderReason) {
        case CardReorderReason.LostOrStolen:
          return 'Lost or Stolen';
        case CardReorderReason.CardNotArrived:
          return 'Not arrived';
        case CardReorderReason.Expired:
          return 'Card has Expired';
      }
      } } as ContentRowField<Order>,
    { header: 'Reorder Comment', cell: (row: Order) => `${row.reorderedCard?.reorderComment}` } as ContentRowField<Order>,

  ] as ContentRowField<Order>[];

  cancellationFields = [
    { header: 'Cancellation reason', cell: (row: Order) => `${row.cancellationReasonName}` } as ContentRowField<Order>,
    { header: 'Cancellation comment', cell: (row: Order) => `${row.cancellationComment}` } as ContentRowField<Order>,
    { header: 'Cancellation date', cell: (row: Order) => `${toDateTimeString(row.cancellationDate) || ''}` } as ContentRowField<Order>,
  ];

  cardFields = [
    { header: 'Card Token', cell: (row: Card) => `${row.token}`, copyCellActive: (row: Card) => true, } as ContentRowField<Card>,
    { header: 'PAN'      , cell: (row: Card) => `${row.maskedPAN || '(unknown)' }` } as ContentRowField<Card>,
    { header: 'Expiry'      , cell: (row: Card) => `${toCardExpireDateString(row.expireDate) || '(unknown)' }` } as ContentRowField<Card>,
    { header: 'Card Type', cell: (row: Card) => `${row.cardTypeName || '(unknown)'}`} as ContentRowField<Card>,
    { header: 'Creation date', cell: (row: Card) => `${toDateTimeString(row.creationDate) || ''}` } as ContentRowField<Card>,
    { header: 'Activation date', cell: (row: Card) => `${toDateTimeString(row.activationDate) || ''}` } as ContentRowField<Card>,
    { header: 'Order date', cell: (row: Card) => `${toDateString(row.orderDate) || ''}` } as ContentRowField<Card>,
    { header: 'Next Annual Fee', cell: (row: Card) => `${toDateString(row.nextAnnualFeeDateDisplayed || row.nextAnnualFeeDate) || ''}` } as ContentRowField<Card>,

    { header: 'SEPA Count', link: (row: Card) => '../../loads/sepas', queryParams: (row: Card) => ({search: row.token}), cell: (row: Card) => this.currentUserIsPartner() ? `${row.sepas.length || 0}` : `${row.sepas.length || 0}` } as ContentRowField<Card>,
    { header: 'SOFORT Count', link: (row: Card) => '../../loads/soforts', queryParams: (row: Card) => ({search: row.token}), cell: (row: Card) => this.currentUserIsPartner() ? `${row.soforts.length || 0}` : `${row.soforts.length || 0}` } as ContentRowField<Card>,


    { header: 'Invoice', link: (row: Card) => '../../invoices/' + this.order?.invoiceId, cell: (row: Card) => `${row.order.invoiceNumber || ''}` } as ContentRowField<Card>,
    { header: 'Payment Reminders', cell: (row: Card) => `${row.order.paymentEmailReminders && row.order.paymentEmailReminders.length || 0}` } as ContentRowField<Card>,
    // { header: "Payment Reminders" , cell: (row: Card) => "<a payment-reminders" + row.token + " " + `${ row.order.paymentEmailReminders.length || 0 }` },
    // DO NOT DELETE
    // { header: "Rec ID", cell: (row: Card) => `${row.recId || ""}` },
    // { header: "Status", cell: (row: Card) => `${row.statusName || ""}` },
    // { header: "Comment", cell: (row: Card) => `${row.comment || ""}` },
    // { header: "Pull date", cell: ( row: Card ) => `${ toDateTimeString( row.pullDate ) || "" }` },
  ];
  reloadDebtorCallback: () => void;
  ipCityInfo: CityInfo|null;
  prevNextIds: PrevNextIdModel;
  loadingPrevNext = false;
  loadingPrev = false;
  loadingNext = false;

  constructor(
    private router: Router,
    private location: Location,
    private route: ActivatedRoute,
    private ordersService: OrdersService,
    private dialog: MatDialog,
    private snackBar: MatSnackBar,
    public roleService: RoleService,
    public cardService: CardsService,
    private logService: EventLogService,
    private datePipe: DatePipe,
    private _toastService: ToastService,
    private geoIpService: GeoIpService,
  ) { }

  ngOnInit() {
    this.route.params.subscribe((params: Params) => {
      const idParam = params['id'];
      this.orderId = idParam;
      this.clearData();
      this.initComponent(idParam);

    });

  }

  currentUserIsPartner() {
    return this.roleService.hasRoles('partner');
  }

  resendWebIdLink(order: Order) {

    this.dialog.open(ResendWebidDialogComponent, {
      data: {
        email: order.email,
      },
    }).afterClosed()
      .subscribe(dlgResult => {
        if (dlgResult instanceof ResendWebidModel) {
          dlgResult.id = order.id;

          this.ordersService.resendWebidLink(dlgResult).subscribe(result => {
            this.snackBar.open('Ident link recreated and e-mail sent.', null, {
              duration: 5000,
              panelClass: ['app-mat-snack-bar']
            });
          });

        }
      });
  }

  showLogs() {
    return this.roleService.hasRoles(['admin']);
  }

  initComponent(orderId: number) {
    this.logService.get( 0, orderId ).subscribe( data => {
      this.logs = data;
    });

    this.getCardData(orderId);
    this.getReferralData(orderId);
    this.getOrderById(orderId);
    this.reloadDebtorCallback = () => {
 this.getOrderById(orderId);
};
    //this.getPrevNext(orderId);
    this.getPrevNextIds(orderId);

  }
  currentUserIsAdmin(): boolean {
    return this.roleService.hasRoles('admin');
  }
  currentUserIsSuperAdmin(): boolean {
    return this.roleService.hasRoles( 'super_admin' );
  }

  updateOrder() {
    this.ordersService.get(this.orderId).subscribe(result => {
      this.order = result;
    });
  }

  returnBack() {
    this.location.back();
  }

  cancelOrderDisabled() {
    return this.order && (this.order.status == OrderStatus.Activated || this.order.status == OrderStatus.Cancelled);
  }

  cancelOrder() {
    this.dialog.open(OrderCancelDialogComponent, { data: { orderId: this.order.id } }).afterClosed()
      .subscribe(dlgResult => {
        if (dlgResult instanceof OrderCancellationModel) {
          this.ordersService.cancelOrder(dlgResult).subscribe(result => {
            this.updateOrder();
            this.snackBar.open('Order has been cancelled', null, {
              duration: 5000,
              panelClass: ['app-mat-snack-bar']
            });
          });
        }
      });
  }

  allowEditOrder() {
    return this.order && this.order.status < OrderStatus.Shipped;
  }

  getOrdersTableFilters() {
    return getTableFilters('ordersTable');
  }

  /*getPrevNext(id: number) {
    const filters = this.getOrdersTableFilters();
    this.ordersService.getPrevNext(filters, id).subscribe(result => {
      this.prevNext = result;
    });
  }*/

  /*gotoPrevOrder() {
    const filters = this.getOrdersTableFilters();
    this.ordersService.getPrev(filters, this.orderId).subscribe(result => {
      this.router.navigate(["..", result], { relativeTo: this.route });
    });
  }*/

  /*gotoNextOrder() {
    const filters = this.getOrdersTableFilters();
    this.ordersService.getNext(filters, this.orderId).subscribe(result => {
      this.router.navigate(["..", result], { relativeTo: this.route });
    });
  }*/

  getPrevNextIds(id: number) {
    const filters = this.getOrdersTableFilters();
    this.ordersService.getPrevNextIds(filters, id).subscribe(result => {
      this.prevNextIds = result;
    });
  }

  gotoPrevOrder() {

    if ( this.prevNextIds?.prevId == null ) {
      this._toastService.error('no previous order');
    }

    this.loadingPrevNext = true;
    this.loadingPrev = true;
    this.router.navigate(['..', this.prevNextIds.prevId], {relativeTo: this.route});
    this.loadingPrevNext = false;
    this.loadingPrev = false;
  }

  gotoNextOrder() {
    if ( this.prevNextIds?.nextId == null ) {
      this._toastService.error('no next order');
    }

    this.loadingPrevNext = true;
    this.loadingNext = true;
    this.router.navigate(['..', this.prevNextIds.nextId], {relativeTo: this.route});
    this.loadingPrevNext = false;
    this.loadingNext = false;
  }


  isResendWebidDisabled() {
    const per = this.roleService.hasRoles(['admin', 'manager', 'agent', 'partner', 'compliance']);
    return !per;
  }

  getOrderById(orderId: number) {
    this.loadingOrder = true;
    this.ordersService.get(orderId)
      .subscribe(order => {
        this.order = order;
        if ( this.order.ipAddress ) {
this.geoIpService.getCityByIp(this.order.ipAddress).subscribe(city => this.ipCityInfo = city, err => {});
}

        this.loadingOrder = false;
      },
        err => {
 this.loadingOrder = false;
});
  }

  getCardData(orderId: number) {
    this.loadCardData = true;
    this.cardService.getForOrder(orderId)
      .subscribe(result => {
        this.card = result;
        this.loadCardData = false;
      });
  }

  getReferralData(orderId: number) {
    this.loadReferralData = true;
    this.ordersService.getReferralForOrder(orderId)
      .subscribe(result => {
        this.referral = result;
        this.loadReferralData = false;
      }, error => {
        this._toastService.error('Unable to load referral: ' + error.message);
      });
  }


  clearData() {
    this.prevNext = null;
  }


  blacklistAppDevice() {

    if (! confirm('Are you sure to blacklist the device of this order?')) {
return;
}

    this.ordersService.blacklistAppDevice(this.orderId).subscribe(result => {
      this._toastService.success('Blacklisted app device');
      this.order.appDevice.isBlacklisted = true;
    }, err => {
      this._toastService.error('Failed to blacklist app device');
    });
  }

  unBlacklistAppDevice() {

    if (! confirm('Are you sure to remove he device of this order from the blacklist?')) {
return;
}

    this.ordersService.unBlacklistAppDevice(this.orderId).subscribe(result => {
      this._toastService.info('Device removed from blacklist');
      this.order.appDevice.isBlacklisted = false;
    }, err => {
      this._toastService.error('Failed to un-blacklist app device');
    });
  }

  protected readonly OrderStatus = OrderStatus;
}
